(function ($) {
    $(document).ready(function () {

        // Keep in sync with source/scss/global/_breakpoints.scss.
        // lightSlider applies settings when window width < breakpoint (strict), so use BS min values (576, 768…).
        const BP_SM = 576;
        const BP_MD = 768;
        const BP_XL = 1200;
        const BP_HERO_LG = 1400;

        const pageHeader = $('.page__header');
        const navbarToggler = $('.navbar-toggler');
        const bsMenu = document.getElementById('navbarNavDropdown');
        // Match Bootstrap `lg` breakpoint and `.navbar-toggler.d-lg-none` visibility ($bp-tablet-max).
        const mobileNavMediaQuery = window.matchMedia('(max-width: 991.98px)');

        /**
         * Mobile: instant full-screen menu (no Bootstrap Collapse, no backdrop scrim).
         */
        const setMobileNavOpen = (open) => {
            if (!mobileNavMediaQuery.matches || !bsMenu) {
                return;
            }

            bsMenu.classList.toggle('show', open);
            navbarToggler.attr('aria-expanded', open ? 'true' : 'false');
            navbarToggler.toggleClass('navbar-toggler--nav-opened', open);
            pageHeader.toggleClass('page__header--mobile-nav-open', open);
            document.body.classList.toggle('mobile-nav-open', open);
        };

        if (bsMenu && navbarToggler.length) {
            let togglerTouchHandled = false;

            const toggleMobileNav = () => {
                setMobileNavOpen(!pageHeader.hasClass('page__header--mobile-nav-open'));
            };

            // iOS/Android fire touchend then a synthetic click — without guard the menu re-opens on close.
            navbarToggler.on('touchend', (event) => {
                if (!mobileNavMediaQuery.matches) {
                    return;
                }

                event.preventDefault();
                togglerTouchHandled = true;
                toggleMobileNav();
            });

            navbarToggler.on('click', (event) => {
                if (!mobileNavMediaQuery.matches) {
                    return;
                }

                event.preventDefault();

                if (togglerTouchHandled) {
                    togglerTouchHandled = false;
                    return;
                }

                toggleMobileNav();
            });

            document.querySelectorAll('.nav-item-anchor').forEach((link) => {
                link.addEventListener('click', () => {
                    if (mobileNavMediaQuery.matches && bsMenu.classList.contains('show')) {
                        setMobileNavOpen(false);
                    }
                });
            });

            mobileNavMediaQuery.addEventListener('change', (event) => {
                if (!event.matches) {
                    setMobileNavOpen(false);
                }
            });
        }

        /**
         * View All button.
         */
        $('.view-all').each(function () {
            $(this).on('click', (e) => {
                e.preventDefault();

                const detailedList = $(this).next('.detailed-list');

                if (!detailedList.hasClass('detailed-list--active')) {
                    detailedList.addClass('detailed-list--active');
                    $(this).addClass('view-all-button--active');
                    $(this).text(wpwc_js_translate.close_all);
                } else {
                    detailedList.removeClass('detailed-list--active');
                    $(this).removeClass('view-all-button--active');
                    $(this).text(wpwc_js_translate.view_all);
                }
            });
        });

        /**
         * Demo carousel (front page).
         */
        const carouselDemoEl = document.getElementById('carouselDemo');
        if (carouselDemoEl && $.fn.lightSlider) {
            $(carouselDemoEl).lightSlider({
                item: 4,
                slideMargin: 10,
                speed: 500,
                auto: true,
                pauseOnHover: true,
                loop: true,
                pause: 1800,
                adaptiveHeight: true,
                controls: false,
                responsive: [
                    {
                        breakpoint: BP_HERO_LG,
                        settings: {
                            item: 3,
                        }
                    },
                    {
                        breakpoint: BP_XL,
                        settings: {
                            item: 2,
                        }
                    },
                    {
                        breakpoint: BP_SM,
                        settings: {
                            item: 1,
                        }
                    },
                ]
            });
        }

        /**
         * Gallery carousels (front page).
         */
        const carouselScreenshotsEl = document.getElementById('carouselScreenshots');
        if (carouselScreenshotsEl && $.fn.lightSlider) {
            $(carouselScreenshotsEl).lightSlider({
                item: 1,
                addClass: 'carouselScreenshots',
                speed: 500,
                auto: true,
                pauseOnHover: true,
                loop: true,
                pause: 2000,
                adaptiveHeight: true,
                controls: false,
                responsive: [
                    {
                        breakpoint: BP_MD,
                        settings: {
                            item: 2,
                        }
                    },
                    {
                        breakpoint: BP_SM,
                        settings: {
                            item: 1,
                        }
                    },
                ]
            });
        }

        if (carouselScreenshotsEl && typeof lightGallery === 'function') {
            lightGallery(carouselScreenshotsEl, {
                plugins: [
                    lgFullscreen,
                    lgZoom,
                    lgThumbnail
                ],
                download: false,
                licenseKey: '0123-4567-890-0987',
            });
        }

        /**
         * Up button.
         */
        const linkHome = $('.link-home');

        if (window.pageYOffset !== 0) {
            pageHeader.addClass('page__header--raised');
        }

        window.addEventListener('scroll', () => {
            const scrolled = window.pageYOffset;

            if (scrolled > 0) {
                pageHeader.addClass('page__header--raised');
            } else {
                pageHeader.removeClass('page__header--raised');
            }

            if (scrolled > 400) {
                linkHome.addClass('link-home--active');
            } else if (!navbarToggler.hasClass('navbar-toggler--nav-opened')) {
                linkHome.removeClass('link-home--active');
            }
        });

        /**
         * Acceptance checkbox.
         */
        $('.your-acceptance').each(function () {
            $(this).on('click', () => {
                $(this).closest('.modal-content__personal').find('.checkbox-icon').toggleClass('active');
            });
        });

        // Clean acceptance checkbox after the form is submitted.
        let checkboxIcons = $('.checkbox-icon');

        document.addEventListener('wpcf7spam', function (event) {
            checkboxIcons.removeClass('active');
            $('.wpcf7-form').removeClass('init');
        }, false);

        document.addEventListener('wpcf7mailsent', function (event) {
            checkboxIcons.removeClass('active');
            $('.wpcf7-form').removeClass('init');
        }, false);

        document.addEventListener('wpcf7mailfailed', function (event) {
            checkboxIcons.removeClass('active');
            $('.wpcf7-form').removeClass('init');
        }, false);

        /**
         * Clean form response after close the modal.
         */
        $('.close-modal').each(function () {
            $(this).on('click', () => {
                $('.wpcf7-response-output').empty();
                $('.wpcf7-form').removeClass(['sent', 'invalid', 'failed']).addClass('init').data('status', 'init');
            });
        });

        /**
         * Add chosen product to the order form.
         */
        $('.order-product').each(function () {
            $(this).on('click', () => {

                let orderValue = '';

                switch ($(this).data('product')) {

                    case 'solution':
                        orderValue = 'Готовое решение';
                        break;

                    case 'integration':
                        orderValue = 'Плагин интеграции';
                        break;

                    case 'renewal':
                        orderValue = 'Продление обновлений';
                        break;

                    default:
                        orderValue = 'Не выбрано';
                }

                $('#chosenProduct').val(orderValue);
            });
        });

        /**
         * Phone mask (iMask).
         */
        let yourTel = document.getElementsByClassName('your-tel'),
            engVersion = document.getElementsByClassName('wpwc-eng');

        if (0 !== yourTel.length && typeof IMask !== 'undefined') {

            Array.from(yourTel).forEach((element) => {

                if (0 === engVersion.length) {
                    let mask = IMask(element, {
                        mask: '+0(000)000-00-00'
                    });
                    mask.value = "+7";

                } else {
                    IMask(element, {
                        mask: '+0[0](000)000-00-00'
                    });
                }
            });
        }

        /**
         * Cookie Notice.
         */
        const cookieNotice = $('#cookieNotice');
        const cookieNoticeAccept = $('#cookieNoticeAccept');

        if (cookieNotice.length > 0) {
            const getCookie = (name) => {
                let matches = document.cookie.match(new RegExp(
                    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
                ));
                return matches ? decodeURIComponent(matches[1]) : undefined;
            };

            const setCookie = (name, value, days) => {
                let expires = "";
                if (days) {
                    let date = new Date();
                    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                    expires = "; expires=" + date.toUTCString();
                }
                document.cookie = name + "=" + (value || "") + expires + "; path=/; secure; samesite=lax";
            };

            if (!getCookie('wpwc_cookie_accepted')) {
                cookieNotice.show();
                setTimeout(() => {
                    cookieNotice.addClass('cookie-notice--visible');
                }, 100);
            }

            cookieNoticeAccept.on('click', () => {
                setCookie('wpwc_cookie_accepted', '1', 365);
                cookieNotice.removeClass('cookie-notice--visible');
                setTimeout(() => {
                    cookieNotice.hide();
                }, 400);
            });
        }

    });/* $(document).ready */

})(jQuery);
